<template>
  <div>
    <router-view />
    <hr />
    <a href="https://member.lge.co.kr/auth/uniPerson.do" target="_blank">LG전자 개인정보 처리방침</a>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
